import { Component } from '@verndale/core';
import addFormLabelsPlaceholder from '../helpers/addFormLabelsPlaceholder';
import setupPhoneInput from '../helpers/setupPhoneInput';
import checkDropdowns from "../helpers/checkDropdowns";

class MastheadForm extends Component {
  setupDefaults() {
    addFormLabelsPlaceholder(this.el);
    setupPhoneInput(this.el);
    checkDropdowns(this.el);
  }
}

export default MastheadForm;
